var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 12.125C1.78125 12.125 1.48688 12.0025 1.24188 11.7575C0.996876 11.5125 0.874584 11.2183 0.875001 10.875V2.125C0.875001 1.78125 0.997501 1.48688 1.2425 1.24188C1.4875 0.996876 1.78167 0.874584 2.125 0.875001H6.5V2.125H2.125V10.875H10.875V6.5H12.125V10.875C12.125 11.2188 12.0025 11.5131 11.7575 11.7581C11.5125 12.0031 11.2183 12.1254 10.875 12.125H2.125ZM5.0625 8.8125L4.1875 7.9375L10 2.125H7.75V0.875001H12.125V5.25H10.875V3L5.0625 8.8125Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.250975b3021ee649873ebefd718a9b03.svg";
export { ForwardRef as ReactComponent };